import React, { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import "./Project.css"
import ApperView from './apperview/ApperView';
import Services from './Services/Services';
import MainConnections from '../MainConnections/MainConnector'
import Sidebar from '../../components/Sidebar/Sidebar';



const Project = () => {
    const [currentPage, setCurrentPage] = useState("services")
    const { projectId } = useParams();
    
    
    const pages = {
            home: <Navigate to="/" replace />,
            map: <ApperView projectId={projectId}/>,
            services: <Services projectId={projectId} />,
            connectors: <MainConnections scope="project" projectId={projectId}/>
        }

    return (
        <div className='project-page'>
            <Sidebar setPage={setCurrentPage} pages={Object.keys(pages)} defultselectedPage='services'/>
            <div className='page-main'>
                {pages[currentPage]}
            </div>
        </div>
    );
};

export default Project;